/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedMobileMoreWaysToBrowse_internalBuyLinks = ReadonlyArray<{
    readonly anchorText: string | null;
    readonly url: string | null;
    readonly " $refType": "SharedMobileMoreWaysToBrowse_internalBuyLinks";
}>;
export type SharedMobileMoreWaysToBrowse_internalBuyLinks$data = SharedMobileMoreWaysToBrowse_internalBuyLinks;
export type SharedMobileMoreWaysToBrowse_internalBuyLinks$key = ReadonlyArray<{
    readonly " $data"?: SharedMobileMoreWaysToBrowse_internalBuyLinks$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedMobileMoreWaysToBrowse_internalBuyLinks">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedMobileMoreWaysToBrowse_internalBuyLinks",
  "type": "InternalBuyLinkType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "anchorText",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "url",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '7a04b744719dfb2ef49a59cd802e22ba';
export default node;
